<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Delete Holder
        </v-card-title>

        <v-card-text light>
          <p><strong>Holder ID</strong>: <code>{{ holder ? holder.id : '' }}</code></p>
          <p><strong>User ID</strong>: <code>{{ holder ? holder.user_id : '' }}</code></p>
          <p><v-divider /></p>
          <p>Are you sure you want to delete this Holder?</p>
          <p>This step can't be reverted.</p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            cancel
          </v-btn>
          <v-btn
            color="error"
            flat
            @click="() => { isVisible = false; $emit('submit') }"
          >
            <v-icon>delete</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'HolderDeleteDialog',
  components: {
  },
  props: {
    visible: Boolean,
    holder: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/payout/HolderDeleteDialog.vue